import {MessageCircle} from "lucide-react";
import {useRideLanguage} from "../ride-language";
import {whatsappHref} from "../ride-utils";

export function WhatsAppContact({phone, message}: {phone?: string; message: string}) {
  const {t} = useRideLanguage();
  const href = whatsappHref(phone, message);
  return <div className="ride-whatsapp">
    {href ? <a className="ride-button ride-button-secondary ride-button-full" href={href} target="_blank" rel="noopener noreferrer">
      <MessageCircle size={18}/>{t("Send WhatsApp")}
    </a> : <><button className="ride-button ride-button-secondary ride-button-full" type="button" disabled aria-describedby="whatsapp-availability">
      <MessageCircle size={18}/>{t("Send WhatsApp")}
    </button><p id="whatsapp-availability" className="ride-help">{t("Driver contact unavailable.")}</p></>}
  </div>;
}
